<p-dialog
  [(visible)]="visible"
  (onHide)="onHideDialog()"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '90vw', height: '80vh' }"
  [header]="
    ('monitoring.fileDetails.title' | translate) +
    (fileName ? ' : ' + fileName : '')
  "
  [maximizable]="true"
  [resizable]="true"
>
  <p-table
    [value]="importItems?.items ?? []"
    [loading]="loading"
    [paginator]="true"
    [rows]="pageSize"
    [first]="first"
    [totalRecords]="importItems?.totalCount ?? 0"
    [lazy]="true"
    [scrollable]="true"
    [tableStyle]="{ 'min-width': '60rem', 'max-width': '100%' }"
    (onLazyLoad)="loadImportItems($event)"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{{ 'monitoring.pagination' | translate }}"
    [rowsPerPageOptions]="rowsPerPageOptions"
    paginatorDropdownAppendTo="body"
  >
    <ng-template pTemplate="loadingicon">
      <i class="pi pi-spinner animate-spin"></i>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th scope="col">{{ "monitoring.table.plaque" | translate }}</th>
        <th scope="col">{{ "monitoring.table.nom" | translate }}</th>
        <th scope="col">{{ "monitoring.table.prenom" | translate }}</th>
        <th scope="col">{{ "monitoring.table.telephone" | translate }}</th>
        <th scope="col">{{ "monitoring.table.email" | translate }}</th>
        <th scope="col">{{ "monitoring.table.langue" | translate }}</th>
        <th scope="col">{{ "monitoring.table.dateFin" | translate }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{ item.plaque }}</td>
        <td>{{ item.nom }}</td>
        <td>{{ item.prenom }}</td>
        <td>{{ item.tel }}</td>
        <td>{{ item.email }}</td>
        <td>{{ item.langue }}</td>
        <td>{{ item.fin | date : "dd/MM/yyyy" }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="11" class="text-center">
          {{ "monitoring.fileDetails.noData" | translate }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <tr style="height: 46px" *ngFor="let i of loadingArray">
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
        <td><p-skeleton width="100%" height="1.2em" /></td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>
